module.exports = __webpack_public_path__ + "img/icon-close.db49e3b5.svg";